import React, { createContext, useContext, useState, useEffect } from 'react';

const RegionContext = createContext();

export const RegionProvider = ({ children }) => {
    const [currentRegion, setCurrentRegion] = useState('north'); // 'north' or 'south'

    // Load region preference from localStorage on mount
    useEffect(() => {
        const savedRegion = localStorage.getItem('hansa-flex-region');
        if (savedRegion && (savedRegion === 'north' || savedRegion === 'south')) {
            setCurrentRegion(savedRegion);
        }
    }, []);

    const switchRegion = (region) => {
        if (region === 'north' || region === 'south') {
            setCurrentRegion(region);
            // Save to localStorage for persistence
            localStorage.setItem('hansa-flex-region', region);
        }
    };

    return (
        <RegionContext.Provider value={{ currentRegion, switchRegion }}>
            {children}
        </RegionContext.Provider>
    );
};

export const useRegion = () => {
    const context = useContext(RegionContext);
    if (!context) {
        throw new Error('useRegion must be used within a RegionProvider');
    }
    return context;
}; 